module.exports = __webpack_public_path__ + "img/ptt_gzh.f1dbe769.jpg";